import MuiTypography from '@mui/material/Typography';
import suppliers from '..';
import { Chip, Grid, Stack } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import TableCellEdit from '../../../components/table/components/TableCellEdit.component';
import { API } from '../api';
import Autocomplete from '../../../components/form/components/Autocomplete.component';
import { PriorityOptions } from './Data.conf';
import { API as categories } from '../../categories/api';
import { API as subCategories } from '../../subCategories/api';
import { API as marina } from '../../marina/api';
import AsyncAutocompleteMultiple from '../../../components/form/components/AsyncAutocompleteMultiple.component';
import _ from 'lodash';
import TextField from '../../../components/form/components/TextField.component';


export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 25,
    },
    sort: {
      by: 'mexal_code',
      direction: 'asc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'attributes.mexal_code',
      key: 'mexal_code',
      sort_key: 'mexal_code',
      sortable: true,
      label: 'Mexal Code',
      display: { xs: 'none', md: 'table-cell' },
    },
    {
      id: 'attributes.label',
      key: 'label',
      sort_key: 'label',
      sortable: true,
      label: 'Supplier',
    },
    {
      id: 'attributes.company_name',
      key: 'company_name',
      sort_key: 'company_name',
      sortable: true,
      label: 'Company name',
    },
    {
      id: 'attributes.category_id',
      key: 'category',
      sort_key: 'id_category.name',
      sortable: true,
      label: 'Categories',
      checkbox: true,
    },
    {
      id: 'attributes.sub_category_id',
      key: 'sub_category',
      sort_key: 'id_sub_category.name',
      sortable: true,
      label: 'Sub-categories',
      checkbox: true,
    },
    {
      id: 'attributes.notes_id',
      key: 'notes_id',
      sort_key: 'notes',
      sortable: true,
      label: 'Notes',
      width: 300,
      checkbox: true,
    },
    {
      id: 'attributes.locations_id',
      key: 'marina',
      sort_key: 'id_locations.marina',
      sortable: true,
      label: 'Location',
      checkbox: true,
    },
    {
      id: 'attributes.supplier_contacts',
      key: 'supplier_contacts',
      sort_key: 'supplier_contacts',
      sortable: true,
      label: 'Supplier contacts',
    },
    {
      id: 'attributes.priority_id',
      key: 'priority_id',
      sort_key: 'priority',
      sortable: true,
      label: 'Priority',
      checkbox: true,
    },
  ],
  render: {
    formatHead: (key, value) => {
      switch (key) {
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value.toUpperCase()}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick) => {
      const renderAllChips = (items = [], getLabel) => {
        if (_.isEmpty(items)) return '-';

        return (
          <Stack direction='row' flexWrap='wrap' useFlexGap gap={0.5}>
            {items.map((item) => (
              <Chip key={item?.id} label={getLabel(item)} size='small' />
            ))}
          </Stack>
        );
      };

      switch (key) {
        case 'marina':
          return (
            <TableCellEdit
              module={{
                ...suppliers,
                query: {
                  ...suppliers.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{
                id_locations: value?.id_locations?.map((item) => ({
                  id: item?.id,
                  name: `${item.attributes.location}${item.attributes.marina ? ` - ${item.attributes.marina}` : ''}${item.attributes.area ? ` - ${item.attributes.area}` : ''}`,
                })),
              }}
              value={value}
              name={'id_locations'}
              form={
                <Grid item xs={12} sm={12}>
                  <AsyncAutocompleteMultiple
                    id='id_locations'
                    name='id_locations'
                    label='Locations'
                    api={marina.select}
                  />
                </Grid>
              }
              width={300}
            >
              {renderAllChips(
                value?.id_locations,
                (item) => item?.attributes?.marina || item?.attributes?.location || '-'
              )}
            </TableCellEdit>
          );

        case 'category':
          return (
            <TableCellEdit
              module={{
                ...suppliers,
                query: {
                  ...suppliers.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{
                id_category: value?.id_category?.map((item) => ({
                  id: item?.id,
                  name: item?.attributes?.name,
                })),
              }}
              value={value}
              name={'id_category'}
              form={
                <Grid item xs={12} sm={12}>
                  <AsyncAutocompleteMultiple
                    id='id_category'
                    name='id_category'
                    label='Categories'
                    api={categories.select}
                  />
                </Grid>
              }
              width={300}
            >
              {renderAllChips(value?.id_category, (item) => item?.attributes?.name || '-')}
            </TableCellEdit>
          );
        case 'sub_category':
          return (
            <TableCellEdit
              module={{
                ...suppliers,
                query: {
                  ...suppliers.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{
                id_sub_category: value?.id_sub_category?.map((item) => ({
                  id: item?.id,
                  name: item?.attributes?.name,
                })),
              }}
              value={value}
              name={'id_sub_category'}
              form={
                <Grid item xs={12} sm={12}>
                  <AsyncAutocompleteMultiple
                    id='id_sub_category'
                    name='id_sub_category'
                    label='Sub Categories'
                    api={subCategories.select}
                  />
                </Grid>
              }
              width={300}
            >
              {renderAllChips(
                value?.id_sub_category,
                (item) => item?.attributes?.name || '-'
              )}
            </TableCellEdit>
          );
        case 'supplier_contacts': {
          const contactsRaw = Array.isArray(value)
            ? value
            : Array.isArray(value?.supplier_contacts)
              ? value.supplier_contacts
              : [];

          const contacts = contactsRaw
            .map((c) => ({
              main_contact: c?.main_contact ?? c?.name ?? null,
              main_contact_phone_number:
                c?.main_contact_phone_number ?? c?.phone ?? null,
              main_contact_email: c?.main_contact_email ?? c?.email ?? null,
            }))
            .filter(
              (c) =>
                c.main_contact ||
                c.main_contact_phone_number ||
                c.main_contact_email
            );

          if (!contacts.length) {
            return <MuiTypography variant='body2'>-</MuiTypography>;
          }

          return (
            <Stack spacing={0.75} sx={{ minWidth: 240 }}>
              {contacts.map((c, idx) => (
                <Stack
                  key={`${c.main_contact || 'contact'}-${idx}`}
                  sx={{
                    px: 1,
                    py: 0.75,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    bgcolor: 'background.paper',
                  }}
                >
                  {c.main_contact ? (
                    <Stack direction='row' spacing={0.5} alignItems='center'>
                      <PersonOutlineIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                      <MuiTypography variant='body2' sx={{ fontWeight: 600 }}>
                        {c.main_contact}
                      </MuiTypography>
                    </Stack>
                  ) : null}

                  {c.main_contact_phone_number ? (
                    <Stack direction='row' spacing={0.5} alignItems='center'>
                      <PhoneOutlinedIcon sx={{ fontSize: 13, color: 'text.secondary' }} />
                      <MuiTypography variant='caption' color='text.secondary'>
                        {c.main_contact_phone_number}
                      </MuiTypography>
                    </Stack>
                  ) : null}

                  {c.main_contact_email ? (
                    <Stack direction='row' spacing={0.5} alignItems='center'>
                      <EmailOutlinedIcon sx={{ fontSize: 13, color: 'text.secondary' }} />
                      <MuiTypography variant='caption' color='text.secondary'>
                        {c.main_contact_email}
                      </MuiTypography>
                    </Stack>
                  ) : null}
                </Stack>
              ))}
            </Stack>
          );
        }
        case 'priority_id':
          return (
            <TableCellEdit
              module={{
                ...suppliers,
                query: {
                  ...suppliers.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ priority: value?.priority }}
              value={value}
              name={'priority'}
              form={
                <Grid item xs={12} sm={12}>
                  <Autocomplete
                    id='priority'
                    name='priority'
                    label='Priority'
                    value={value?.priority ? { label: value?.priority } : null}
                    options={PriorityOptions}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.priority || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'notes_id':
          return (
            <TableCellEdit
              module={{
                ...suppliers,
                query: {
                  ...suppliers.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ notes: value?.notes }}
              value={value}
              name={'notes'}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='notes'
                    name='notes'
                    label='Notes'
                    type='text'
                    multiline
                    rows={5}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.notes || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        default:
          return (
            <MuiTypography variant='body1' onClick={onClick}>
              {value ? value : '-'}
            </MuiTypography>
          );
      }
    },
  },
};
